import AuthService from "../services/authService";

let authRedirectStarted = false;

function redirectToLogin() {
  AuthService.removeAuth();

  if (!authRedirectStarted && window.location.pathname !== "/admin/login") {
    authRedirectStarted = true;
    window.location.replace("/admin/login");
  }
}

async function fetchAuth(input: RequestInfo | URL, init?: RequestInit | undefined): Promise<Response> {
  const accessToken = AuthService.getAccessToken();

  const response = await fetch(input, {
    ...(init ?? {}),
    headers: {
      ...(init?.headers ?? {}),
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      ["ngrok-skip-browser-warning"]: "hello",
      // "Content-Type": "application/json",
    },
  });

  if (response.status === 401 || response.status === 403) {
    redirectToLogin();
  }

  return response;
}

export default fetchAuth;
